"use client";

import { FC, ReactNode } from "react";
import TextTitle from "apps/website/components/base/Text/TextTitle/TextTitle";
import TextBody from "apps/website/components/base/Text/TextBody/TextBody";
import type {
  TextTitleVariantsProps,
} from "apps/website/components/base/Text/TextTitle/styles";
import cx from "apps/website/utils/misc/cx";

export interface TitleSectionProps {
  title: string | undefined;
  subtitle?: ReactNode;
  bgClassName?: string;
  titleSize?: NonNullable<TextTitleVariantsProps["size"]>;
}

export const TitleSection: FC<TitleSectionProps> = ({
  title,
  subtitle,
  bgClassName = "bg-white",
  titleSize = 3,
}) => {
  if (!title) {
    return null;
  }

  return (
    <div className={cx(bgClassName, "pt-2 pb-2 lg:pb-3")}>
      <TextTitle size={titleSize} align="center" className="px-4" data-testid="signup-step-heading">
        { title }
      </TextTitle>
      { subtitle && (
        <TextBody size={2} align="center" className="px-4 !mb-0">
          { subtitle }
        </TextBody>
      ) }
    </div>
  );
};
